type TrackingData = Record<string, unknown> & { event?: string };

function convertToAcdl(data: TrackingData) {
  const acdl: { event?: string; eventInfo: Record<string, unknown> } = {
    eventInfo: {},
  };
  if (data.event) {
    acdl.event = data.event;
    delete data.event;
  }
  acdl.eventInfo = data;
  return acdl;
}

export function addToTrackingData(data: TrackingData) {
  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(convertToAcdl({...data}));
}
